export default __webpack_public_path__ + "static/media/AccederOctubre6.3273e605.png";